// @flow
import type { Location } from 'react-router-dom';

const checkoutPath = /.*\/cart\/.*/;
const paymentReturnPath = /.*\/payment-return/;
const awaitingPaymentPath = /.*\/awaiting-payment\/.*/;
const cartOverviewPath = /.*\/cart\/(([0-9a-f]-?)+\/)?overview.*/;
const studioPath = /.*\/studio\/.*/;

export const getIsCheckoutPage = (location: Location): boolean =>
  checkoutPath.test(location.pathname) ||
  awaitingPaymentPath.test(location.pathname) ||
  paymentReturnPath.test(location.pathname);

export const getIsStudioPage = (location: Location): boolean =>
  studioPath.test(location.pathname);

export const getIsCartOverviewPage = (location: Location): boolean =>
  cartOverviewPath.test(location.pathname) ||
  paymentReturnPath.test(location.pathname);
